import React, { useCallback, useState } from "react";
import { not } from "ramda";

import { withTheme } from "styles/styled_components";

import { IThemeInterface } from "styles/theme";

import CheckmarkIcon from "components/shared/icon_types/checkmark";
import ChevronDownIcon from "components/shared/icon_types/chevron_down";
import DownArrowIcon from "components/shared/icon_types/down_arrow";
import EditIcon from "components/shared/icon_types/edit";
import FilterIcon from "components/shared/icon_types/filter";
import InfoCircle from "components/shared/icon_types/info_circle";
import MinusCircleSolidIcon from "components/shared/icon_types/minus_circle_solid";
import MinusSign from "components/shared/icon_types/minus_sign";
import MoreVert from "components/shared/icon_types/more_vert";
import PlusCircleSolidIcon from "components/shared/icon_types/plus_circle_solid";
import PlusSignIcon from "components/shared/icon_types/plus_sign";
import TrashIcon from "components/shared/icon_types/trash";
import UploadIcon from "components/shared/icon_types/upload";
import XIcon from "components/shared/icon_types/x";

export enum ICON_TYPE {
  CHECKMARK = "CheckmarkIcon",
  CHEVRON_DOWN = "ChevronDownIcon",
  DOWN_ARROW = "DownArrowIcon",
  EDIT = "EditIcon",
  FILTER = "FilterIcon",
  INFO_CIRCLE = "InfoCircle",
  MINUS_CIRCLE_SOLID = "MinusCircleSolidIcon",
  MINUS_SIGN = "MinusSign",
  MORE_VERT = "MoreVert",
  PLUS_CIRCLE_SOLID = "PlusCircleSolidIcon",
  PLUS_SIGN = "PlusSignIcon",
  TRASH = "TrashIcon",
  UPLOAD = "UploadIcon",
  X = "XIcon",
}

export enum ICON_COLOR {
  BLUE = "dsBlueDark",
  GRAY = "brandGray30",
  ORANGE = "dsOrangeUpserve",
  WHITE = "brandWhite",
}

const ICON_COMPONENTS = {
  CheckmarkIcon,
  ChevronDownIcon,
  DownArrowIcon,
  EditIcon,
  FilterIcon,
  InfoCircle,
  MinusCircleSolidIcon,
  MinusSign,
  MoreVert,
  PlusCircleSolidIcon,
  PlusSignIcon,
  TrashIcon,
  UploadIcon,
  XIcon,
};

interface IIconProps extends React.SVGAttributes<SVGSVGElement> {
  size?: string;
  color?: ICON_COLOR;
  lightenOnHover?: boolean;
  theme: IThemeInterface;
  type: ICON_TYPE;
}

function Icon({
  size,
  color = ICON_COLOR.BLUE,
  lightenOnHover,
  type,
  theme,
  ...rest
}: IIconProps) {
  const iconSize = size || theme.iconSize.small;

  const [isHovered, setHover] = useState(false);
  const toggleHover = useCallback(
    event => {
      event.stopPropagation();
      if (lightenOnHover) {
        setHover(not);
      }
    },
    [isHovered, lightenOnHover]
  );

  const finalColor = () => {
    switch (color) {
      case ICON_COLOR.BLUE:
        return theme.colors.lspdBlue500;
      case ICON_COLOR.GRAY:
        return theme.colors.lspdGray800;
      default:
        return theme.colors.brandWhite;
    }
  };

  const DynamicIcon = ICON_COMPONENTS[type];
  return (
    <DynamicIcon
      color={finalColor()}
      size={iconSize}
      onMouseOver={toggleHover}
      onMouseOut={toggleHover}
      {...rest}
    />
  );
}

export default withTheme(Icon);
